import React from 'react';
import styled from 'styled-components';

import type { IModalContainer } from './types';

import { PanelLabel } from '@/components/common';
import { CrossIcon } from '@/assets/icons';
import { media } from '@/styles/theme';
import { useKeyDown } from '@/hooks';

const ModalContainer = ({ title, children, handleClose }: IModalContainer): React.ReactElement => {
  useKeyDown('Escape', handleClose);

  return (
    <Container>
      <Modal>
        <Body>
          <PanelLabel linesPosition="top">{title}</PanelLabel>
          {children}
          {handleClose && <CloseModalIcon onClick={handleClose} />}
        </Body>
      </Modal>
    </Container>
  );
};

export { ModalContainer };

const Container = styled.div.attrs({
  className: `w-100 h-100`,
})`
  position: fixed;
  top: 0;
  left: 0;
  padding: 68px 6px 10px 6px;
  background-color: #c4c4c46b;
  z-index: 9999;
`;

const Body = styled.div`
  position: relative;
  max-height: 80vh;
  padding: 35px 30px;
  overflow-y: auto;
`;

const Modal = styled.div.attrs({
  className: 'w-100 bg-white',
})`
  position: relative;
  max-width: 984px;
  margin: 0;
  box-shadow: 0 30px 50px rgba(0, 0, 0, 0.1);
  border: 1px solid #fff;
  border-radius: 16px;

  ${media.tablet} {
    margin: auto;
  }
`;

const CloseModalIcon = styled.div`
  position: absolute;
  top: 35px;
  right: 38px;

  height: 12px;
  width: 12px;

  background-image: url(${CrossIcon});
  background-repeat: no-repeat;
  cursor: pointer;
`;
